/**
 * Copyright (c) Microsoft Corporation
 * All rights reserved. See License.txt in the project root for license information.
 * IExtCartIcon containerModule Interface Properties
 * THIS FILE IS AUTO-GENERATED - MANUAL MODIFICATIONS WILL BE LOST
 */

import * as Msdyn365 from '@msdyn365-commerce/core';
import * as React from 'react';

export const enum cartLinesSortOrder {
    ascending = 'ascending',
    descending = 'descending'
}

export interface IExtCartIconConfig extends Msdyn365.IModuleConfig {
    imageSettings?: Msdyn365.IImageSettings;
    enableHoverCart?: boolean;
    showCheckoutButton?: boolean;
    showCartButton?: boolean;
    checkoutButtonTitle?: string;
    cartLinesSortOrder?: cartLinesSortOrder;
    showFreeDeliveryText?: boolean;
    untilFreeDeliveryText?: string;
    freeDeliveryReachedText?: string;
    freeDeliveryAmountGuest?: number;
    freeDeliveryAmountMember?: number;
    totalPriceFormatString?: string;
    showSubtotalMessage?: boolean;
    subtotalMessageUntilFreeShipping?: string;
    subtotalMessageOnFreeShipping?: string;
    isAnonymousCheckout?: boolean;
    clientRender?: boolean;
    popupContentText?: string;
    showPaymentImages?: boolean;
    paymentImages?: Msdyn365.IImageData[];
    cartUpdateToggle?: boolean;
    removeUserCartItems?: boolean;
    displayCartUpdate?: boolean;
}

export interface IExtCartIconResources {
    cartUpdateMessage: string;
    cartUpdateButtonMessage: string;
    cartLinkButtonMessage: string;
    goToCartButtonTitle: string;
    totalPriceFormatString: string;
    guestCheckoutButtonTitle: string;
    checkoutButtonTitle: string;
    productDimensionTypeColor: string;
    productDimensionTypeSize: string;
    productDimensionTypeStyle: string;
    productDimensionTypeConfiguration: string;
    quantityDisplayText: string;
    removeCartButtonText: string;
    cartLabel: string;
    cartQtyLabel: string;
    flyoutTitle: string;
    salesAgreementPricePrompt: string;
    shippingText: string;
    checkoutBlockedDueToUnavailableFundsTitle: string;
    checkoutBlockedDueToUnavailableFundsMessage: string;
    memberPriceMessage: string;
    saleMessage: string;
    outOfStockText: string;
    outOfRangeOneText: string;
}

export interface IExtCartIconProps<T> extends Msdyn365.IModule<T> {
    resources: IExtCartIconResources;
    config: IExtCartIconConfig;
    slots: {
        popupContent: React.ReactNode[];
    };
}
